var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-card-group',{attrs:{"deck":""}},[_c('ManageSubscriptionCouponVue')],1),_c('ManageSubscriptionCouponTable')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }